<app-demo [datasource]="datasource" [context]="demoContext" [sources]="sources">
  <div description>
    <p>
      Speaking of what impact could <em>Settings</em> have on the Scroller
      behavior, we need to get an idea of its behavior before any settings
      applied. This demo is the very basic example with no
      <em>Settings</em> provided.
    </p>
    <p>
      Let's first investigate the demo's log. The visible part of the viewport
      contains 10 items in accordance with CSS: 10 items of 25px each are equal
      to 250px of the viewport height.
      <em>Datasource.get</em> log shows that there were 3 requests of 5, 10 and
      5 items on the initial load (before any scrolling). So we have 20 DOM
      elements initially: 15 downward items with positive indexes and 5 upward
      negative items. 20 items result in 500px and this is the initial viewport
      scrollable size.
    </p>
    <p>
      The viewport scrollable size value can increase only; as we scroll more
      and more, items flow through the <em>Datasource.get</em>. In this demo the
      <em>Datasource</em> is unlimited, it produces items with indexes from
      -Infinity to +Infinity. The number of DOM elements in the viewport is not
      constant, but it fluctuates around the initial value during scrolling
      (20-31). The core concept of the virtualization is to keep as small number
      of real items as needed while the scrollable size of the viewport can be
      very big.
    </p>
    <p>
      Why do we have 3 requests initially, why the first one is about only 5
      items, why at least 10 items are invisible? This is how the
      <em>*uiScroll</em> works and further reading should shed light on the
      details. But we need to know that the default behavior could be changed
      via <em>Settings</em> object.
    </p>
  </div>
</app-demo>
